import { toast as sonnerToast, ExternalToast } from "sonner";
import { TOAST_DURATION, VARIANT_CLASS } from "./consts";
import { ToastFn, ToastVariant } from "./types";

const show = (
  message: string,
  variant: ToastVariant = "success",
  options?: ExternalToast
) => {
  return sonnerToast[variant](message, {
    ...options,
    duration: options?.duration ?? TOAST_DURATION,
    className: VARIANT_CLASS[variant],
  });
};

const toast = ((message: string, options?: ExternalToast) =>
  show(message, "success", options)) as ToastFn;

toast.success = (message, options) => show(message, "success", options);
toast.error = (message, options) => show(message, "error", options);
toast.warning = (message, options) => show(message, "warning", options);

export { toast };
export default toast;
